module.exports = __webpack_public_path__ + "img/1.e66948c7.jpg";